import { useEffect, DependencyList } from 'react';
import { useDidUpdate } from '../useDidUpdate';

export function useDelayCall(fn: ()=>any, deps?: DependencyList, callOnFirstRender = false) {
  const didUpdate = useDidUpdate();
  useEffect(() => {
    const timer = setTimeout(() => {
      if (didUpdate) {
        fn();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, deps);

  useEffect(
    () => {
      if (callOnFirstRender) {
        fn();
      }
    },
    [],
  );
}
